import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PageNotFound from "./PageNotFound";
import { Provider } from "react-redux";

import store from "./store";

if (document.getElementById('root') as HTMLElement) {
  const urlParams = new URLSearchParams(document.location.search);

  const apiKey = urlParams?.get("apiKey");

  const config = {
    hideAppBar: urlParams?.get('hideAppBar')!,
    sessionId: urlParams?.get('sessionId')!,
  }

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            {/* <Route path="/simplified" element={<App />} /> */}
            <Route path="client" element={<App apiKey={apiKey!} config={config!} />} />
            <Route path="404" element={<PageNotFound />} />
            <Route path="*" element={<Navigate replace to="/404" />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

const renderApp = (apiKey: string, appConfig: any, element: any) => {
  if (element) {
    ReactDOM.render(
      <Provider store={store}>
        <App apiKey={apiKey} config={appConfig} />
      </Provider>,
      element
    )
  } else {
    throw new Error('Element does not exist.')
  }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export { renderApp }